import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, Package, Video, Handshake, Megaphone, Globe, CheckCircle, XCircle, ChevronDown, Play, ArrowRight, MessageCircle, Search, FileText, Rocket } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
export function CoachingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/3zsvshqebj.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      if (document.head.contains(playerScript)) document.head.removeChild(playerScript);
      if (document.head.contains(embedScript)) document.head.removeChild(embedScript);
    };
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Cómo funciona el coaching VIP 1:1?',
    a: 'Hacemos un diagnóstico profundo de tu negocio, definimos el plan de acción personalizado y trabajamos juntos en la implementación. La frecuencia y formato de las sesiones se adapta a tu situación específica.'
  }, {
    q: '¿Cuánto tiempo dura el programa?',
    a: 'Depende de tus objetivos y el nivel de acompañamiento que necesitas. Discutimos esto en la llamada inicial para diseñar el plan correcto para ti.'
  }, {
    q: '¿Necesito tener ya un negocio funcionando?',
    a: 'No necesariamente. Trabajo tanto con personas que quieren construir desde cero como con marcas establecidas que quieren escalar. Lo importante es que tengas la mentalidad y el capital para invertir.'
  }, {
    q: '¿Cómo me contacto para empezar?',
    a: 'Simplemente haz clic en el botón de WhatsApp y cuéntame brevemente tu situación. Te responderé personalmente para agendar una llamada de diagnóstico.'
  }];
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc] selection:text-black overflow-x-hidden" data-id="element-1449" data-mp="87hopfh2enor">
      <VslHeader data-id="element-1450" data-mp="d8ng99yzo4wp" />

      {/* Scrolling Marquee Banner */}
      <div className="fixed top-[40px] md:top-[48px] left-0 right-0 z-40 bg-[#00f7fc] text-black py-1.5 overflow-hidden border-b border-black/10 shadow-md" data-id="element-1451" data-mp="i78gvai5kqlo">
        <div className="whitespace-nowrap flex items-center animate-marquee text-[10px] md:text-xs font-black tracking-widest uppercase" data-id="element-1452" data-mp="2jxk2j7syb5ox">
          <span className="mx-4" data-id="element-1453" data-mp="2ox6frh8s4lxq">+$50M EN RESULTADOS COLECTIVOS</span>
          <span className="mx-2" data-id="element-1454" data-mp="161sbk9s6mz4w">◆</span>
          <span className="mx-4" data-id="element-1455" data-mp="162jzqzjg9ul5">
            ECOMMERCE · PRODUCTOS DIGITALES · FUNNELS
          </span>
          <span className="mx-2" data-id="element-1456" data-mp="119929p0j2q5w">◆</span>
          <span className="mx-4" data-id="element-1457" data-mp="x8p2seshfagl">META ADS · YOUTUBE ADS · AFILIADOS</span>
          <span className="mx-2" data-id="element-1458" data-mp="x6kpx7clv146">◆</span>
          <span className="mx-4" data-id="element-1459" data-mp="sand3b0jwcw5">PAY PER CALL · MLM · DTC</span>
          <span className="mx-2" data-id="element-1460" data-mp="1p04p07q4mv6a">◆</span>
          <span className="mx-4" data-id="element-1461" data-mp="1oz3cdytgq0mg">WEBINARS · VSL · RETARGETING</span>
          <span className="mx-2" data-id="element-1462" data-mp="1kysx1vjs5xux">◆</span>
          <span className="mx-4" data-id="element-1463" data-mp="1kzuj0v2c44rf">ESTRATEGIA PERSONALIZADA 1:1</span>

          {/* Duplicate for seamless loop */}
          <span className="mx-2" data-id="element-1464" data-mp="1fxlo3t5wismo">◆</span>
          <span className="mx-4" data-id="element-1465" data-mp="1b0ltceei5cav">+$50M EN RESULTADOS COLECTIVOS</span>
          <span className="mx-2" data-id="element-1466" data-mp="1b2g5b37spu2t">◆</span>
          <span className="mx-4" data-id="element-1467" data-mp="4kt08tg8eobw">
            ECOMMERCE · PRODUCTOS DIGITALES · FUNNELS
          </span>
          <span className="mx-2" data-id="element-1468" data-mp="3vqb7ep7dsu2i">◆</span>
          <span className="mx-4" data-id="element-1469" data-mp="3vp9ibgtj671s">META ADS · YOUTUBE ADS · AFILIADOS</span>
          <span className="mx-2" data-id="element-1470" data-mp="1ngtjogky659u">◆</span>
          <span className="mx-4" data-id="element-1471" data-mp="1ng1q1bawuhm7">PAY PER CALL · MLM · DTC</span>
          <span className="mx-2" data-id="element-1472" data-mp="1s9ecpfw14ecb">◆</span>
          <span className="mx-4" data-id="element-1473" data-mp="1safsfxnzpp0d">WEBINARS · VSL · RETARGETING</span>
          <span className="mx-2" data-id="element-1474" data-mp="1eirfjs5x2wic">◆</span>
          <span className="mx-4" data-id="element-1475" data-mp="1jgauyvecpfbv">ESTRATEGIA PERSONALIZADA 1:1</span>
        </div>
      </div>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[500px] md:h-[700px] z-0 opacity-40" data-id="element-1476" data-mp="275lte688axmu">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-1477" data-mp="2b7qnf62l9wa0" />
      </div>

      <main className="relative z-10 pt-32 md:pt-40 pb-20" data-id="element-1478" data-mp="lr7sfx678yb2">
        {/* 2. HERO SECTION */}
        <section className="max-w-4xl mx-auto px-4 text-center mb-20 md:mb-32" data-id="element-1479" data-mp="qsx2palll7y3">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 px-4 py-1.5 rounded-full mb-6" data-id="element-1480" data-mp="j6rttollicih">
            <span className="relative flex h-2 w-2" data-id="element-1481" data-mp="na7oife3u2sj">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00f7fc] opacity-75" data-id="element-1482" data-mp="3vozuqrz8uvsx"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00f7fc]" data-id="element-1483" data-mp="3roxpy9y7pm9f"></span>
            </span>
            <span className="text-[#00f7fc] font-bold text-xs uppercase tracking-widest" data-id="element-1484" data-mp="9aorahmu0bv0">
              Coaching VIP 1:1 Exclusivo
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-white mb-6" data-id="element-1485" data-mp="3cy8dz5cxg34i">
            Escala Tu Marca Con La Estrategia Exacta Que Generó{' '}
            <span className="text-[#00f7fc]" data-id="element-1486" data-mp="1lmu4agr33cvx">+$50M</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-base md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-1487" data-mp="1loy5us1ifzt1">
            Un plan de acción 100% personalizado para tu negocio. Ya sea que
            estés construyendo desde cero o escalando una marca establecida,
            trabajo contigo directamente para diseñar e implementar la
            estrategia correcta.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="w-full max-w-md mx-auto mb-12" data-id="element-1488" data-mp="2eazon2e86zv8">
            <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
            boxShadow: '0 0 20px rgba(253, 185, 49, 0.25), 0 0 40px rgba(253, 185, 49, 0.1)'
          }} data-id="element-1489" data-mp="2oytrpnshrf4">
              <span className="absolute inset-0 rounded-xl animate-pulse" style={{
              boxShadow: '0 0 25px rgba(253, 185, 49, 0.35), 0 0 50px rgba(253, 185, 49, 0.15)'
            }} data-id="element-1490" data-mp="3b494fm5qw4yi" />
              <MessageCircle className="relative z-10 w-6 h-6" data-id="element-1491" data-mp="19b1bvb14fquo" />
              <span className="relative z-10" data-id="element-1492" data-mp="14cq6pdlru4is">Contáctame en WhatsApp</span>
              <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-1493" data-mp="d7x9s14ayfnm">
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-1494" data-mp="da9s4fdz2s17" />
              </div>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto border-t border-white/10 pt-8" data-id="element-1495" data-mp="8gnk50ir7cbq">
            <div data-id="element-1496" data-mp="3gpfdpxgyf2ir">
              <p className="text-3xl font-black text-white mb-1" data-id="element-1497" data-mp="3gpxixjllgr2t">$50M+</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-1498" data-mp="3lmxh78c7cpjd">
                Resultados colectivos
              </p>
            </div>
            <div data-id="element-1499" data-mp="1evg89sqijfdz">
              <p className="text-3xl font-black text-white mb-1" data-id="element-1500" data-mp="1jw3u7zzvx61c">10+</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-1501" data-mp="1ju9j1def0sag">
                Años de experiencia
              </p>
            </div>
            <div data-id="element-1502" data-mp="2zgcv39vs30sm">
              <p className="text-3xl font-black text-white mb-1" data-id="element-1503" data-mp="2zgv1v0g2gxes">6</p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-1504" data-mp="3e4g12j9tmchf">
                Áreas de expertise
              </p>
            </div>
          </motion.div>
        </section>

        {/* 3. VIDEO SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 mb-24" data-id="element-1505" data-mp="3n3bcc9rq2crl">
          <div className="text-center mb-8" data-id="element-1506" data-mp="3i4rou4xhcsx4">
            <h2 className="text-2xl md:text-4xl font-black text-white mb-3" data-id="element-1507" data-mp="3i85nb230whza">
              Mira Este Video Primero
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1508" data-mp="3s3fojnllklc0">
              Por Qué Este Coaching Es Diferente
            </p>
          </div>

          <div className="relative bg-gray-900 border border-[#00f7fc]/30 overflow-hidden shadow-2xl rounded-2xl" style={{
          boxShadow: '0 0 10px rgba(0, 247, 252, 0.15), 0 0 30px rgba(0, 247, 252, 0.08)'
        }} data-id="element-1509" data-mp="22pkqb8eaov65">
            <style dangerouslySetInnerHTML={{
            __html: `wistia-player[media-id='3zsvshqebj']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3zsvshqebj/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`
          }} data-id="element-1510" data-mp="298bh2h26bv6k" />
            <wistia-player media-id="3zsvshqebj" aspect="1.7777777777777777" data-id="element-1511" data-mp="1uf8at5u193v5"></wistia-player>
          </div>
        </motion.section>

        {/* 4. EXPERTISE GRID */}
        <motion.section {...fadeIn} className="max-w-6xl mx-auto px-4 mb-24" data-id="element-1512" data-mp="2n3437yckk9m4">
          <div className="text-center mb-12" data-id="element-1513" data-mp="2iaaz9coxd5b3">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1514" data-mp="2i99kax4sfyo3">
              Áreas de Expertise
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1515" data-mp="3ardkqo2r2b7g">
              Domino Cada Área Donde Tu Marca Necesita Crecer
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1516" data-mp="35zccdd8pd4mp">
            {[{
            icon: ShoppingCart,
            title: 'Ecommerce & DTC',
            desc: 'Marcas directas al consumidor, optimización de tiendas, estrategias de retención y escalamiento con paid traffic.'
          }, {
            icon: Package,
            title: 'Productos Digitales',
            desc: 'Creación, lanzamiento y escalamiento de infoproductos, cursos, membresías y software.'
          }, {
            icon: Video,
            title: 'Webinars & VSL Funnels',
            desc: 'Diseño de embudos de alta conversión: webinars en vivo, VSLs, páginas de ventas y secuencias de email.'
          }, {
            icon: Handshake,
            title: 'Afiliados & Pay Per Call',
            desc: 'Redes de afiliados, arbitraje de tráfico, pay per call y modelos de revenue share.'
          }, {
            icon: Megaphone,
            title: 'Meta Ads & YouTube Ads',
            desc: 'Estrategia de campañas, creativos, audiencias, retargeting y optimización de ROAS.'
          }, {
            icon: Globe,
            title: 'MLM & Marketing de Red',
            desc: 'Estrategias de reclutamiento digital, duplicación de equipos y construcción de marca personal para líderes de red.'
          }].map((item, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 hover:border-[#00f7fc]/30 transition-all duration-300 group" data-id="element-1517" data-mp="8vujqnqsi4hz" data-mpi={i}>
                <div className="w-14 h-14 bg-[#00f7fc]/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-1518" data-mp="ht4u86vs9plu">
                  <item.icon className="w-7 h-7 text-[#00f7fc]" data-id="element-1519" data-mp="rt5hu50oqrvu" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1520" data-mp="mt9ca1ccase6">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-1521" data-mp="2tla4p23buyzp">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </motion.section>

        {/* 5. RESULTS SECTION */}
        <motion.section {...fadeIn} className="max-w-5xl mx-auto px-4 mb-24" data-id="element-1522" data-mp="144fwv1butj1y">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-1523" data-mp="192hhhqoxhqfj">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00f7fc] to-blue-600" data-id="element-1524" data-mp="ub7hvurehjc4"></div>

            <h2 className="text-2xl md:text-4xl font-black text-white text-center mb-12" data-id="element-1525" data-mp="za1zwuhjn3v6">
              +$50M Generados En Múltiples Industrias
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1526" data-mp="pf097u7mdtqh">
              <div className="text-center" data-id="element-1527" data-mp="bfhf45bn8ix6">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1528" data-mp="bgk0xyu3zv68">$50M+</p>
                <p className="text-white font-bold mb-1" data-id="element-1529" data-mp="ge2c7vvlmmhe">
                  Generados colectivamente
                </p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1530" data-mp="25qnr6s0pj90o">
                  En todas las áreas combinadas
                </p>
              </div>
              <div className="text-center" data-id="element-1531" data-mp="ao0qx3ue64ls">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1532" data-mp="5q7nujodxqpq">10+</p>
                <p className="text-white font-bold mb-1" data-id="element-1533" data-mp="5o4ova598n8v">Años de experiencia</p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1534" data-mp="1n2p8s7fe96d">
                  En marketing digital
                </p>
              </div>
              <div className="text-center" data-id="element-1535" data-mp="3nwdowqqj6vcx">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1536" data-mp="3nxf3342ufxyv">6</p>
                <p className="text-white font-bold mb-1" data-id="element-1537" data-mp="3j42nfjg571i9">Modelos de negocio</p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1538" data-mp="3e5j29l9dhtqy">
                  Dominados y probados
                </p>
              </div>
              <div className="text-center" data-id="element-1539" data-mp="3a2cmnn0deq7t">
                <p className="text-4xl font-black text-[#00f7fc] mb-2" data-id="element-1540" data-mp="355w0uzgn8nxw">1:1</p>
                <p className="text-white font-bold mb-1" data-id="element-1541" data-mp="3069o0r4q99pm">
                  Coaching personalizado
                </p>
                <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-1542" data-mp="1foqpxff7dyzy">
                  Plan único para tu negocio
                </p>
              </div>
            </div>
          </div>

          {/* Revenue Growth Screenshot */}
          <div className="mt-12 max-w-2xl mx-auto" data-id="element-1543" data-mp="1pmwr1ut6r13r">
            <div className="text-center mb-6" data-id="element-1544" data-mp="1toi8ltgo03ka">
              <p className="text-[#00f7fc] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-1545" data-mp="1tn741rfears4">
                Crecimiento Real — Mis Propios Números
              </p>
              <p className="text-gray-400 text-base" data-id="element-1546" data-mp="11xvmiinh4a3r">
                De $20K a $154K/mes en solo 4 meses. Esto es lo que pasa cuando
                aplicas la estrategia correcta.
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl" style={{
            boxShadow: '0 0 20px rgba(0, 247, 252, 0.1)'
          }} data-id="element-1547" data-mp="1apxh40av2w64">
              <img src="https://cdn.magicpatterns.com/uploads/xwr3dSQ4TK8CGc5hG5nfVJ/Screenshot_2026-04-08_at_4.38.44_PM.png" alt="Crecimiento de ingresos — de $20K en Diciembre a $154,919 en Marzo" className="w-full h-auto block" data-id="element-1548" data-mp="i81ohmu60yr3" />
            </div>
          </div>
        </motion.section>

        {/* 5.5 CLIENT TESTIMONIALS */}
        <motion.section {...fadeIn} className="max-w-6xl mx-auto px-4 mb-24" data-id="element-1549" data-mp="1v90q6kft0v4x">
          <div className="text-center mb-12" data-id="element-1550" data-mp="1qbicyhur7tr4">
            <span className="bg-[#00f7fc]/10 text-[#00f7fc] border border-[#00f7fc]/20 px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-4 inline-block" data-id="element-1551" data-mp="1qcth4is433ir">
              Resultados Reales
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1552" data-mp="1blb1wn72td0g">
              Lo Que Dicen Mis Clientes 1:1
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1553" data-mp="17j6fo9iyjinu">
              Todos estos clientes han generado más de 7 cifras con mi coaching.
              Escucha directamente de ellos — desliza para ver más →
            </p>
          </div>

          <div className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-2" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-1554" data-mp="2qinklk8h9sf2">
            {/* David Moreno - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-1555" data-mp="2gkzpgt6ymiwd">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1556" data-mp="2ljkjubzj68cw">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-1557" data-mp="39agdlenjrdms">
                  <iframe src="https://player.vimeo.com/video/1163771829?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="David Moreno Testimonial" data-id="element-1558" data-mp="3eab4vjb8i58d" />
                </div>
                <div className="p-4" data-id="element-1559" data-mp="1s5i1p8aibyhp">
                  <p className="text-sm font-bold text-white" data-id="element-1560" data-mp="1s4gjmjv2qbqh">David Moreno</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1561" data-mp="1o4y3e1e76otz">
                    Cliente 1:1
                  </p>
                </div>
              </div>
            </div>

            {/* Richard & Laz - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-1562" data-mp="2fszu961lj0lq">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1563" data-mp="2buik0dmvpa03">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-1564" data-mp="21w2uug7ewat8">
                  <iframe src="https://player.vimeo.com/video/1163509676?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Richard & Laz Testimonial" data-id="element-1565" data-mp="vgaabjn7iv5v" />
                </div>
                <div className="p-4" data-id="element-1566" data-mp="z2z0ca3ov2ku">
                  <p className="text-sm font-bold text-white" data-id="element-1567" data-mp="z1xf5csykzpe">Richard & Laz</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1568" data-mp="141imaaia8ed7">
                    Clientes 1:1
                  </p>
                </div>
              </div>
            </div>

            {/* Carwin - Vertical */}
            <div className="flex-shrink-0 w-[70vw] md:w-[280px] snap-center" data-id="element-1569" data-mp="1dywpv9j3x8o3">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1570" data-mp="3at9lzfwubzpc">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-1571" data-mp="3ftp3mjo5ntd4">
                  <iframe src="https://player.vimeo.com/video/1163416902?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Carwin Testimonial" data-id="element-1572" data-mp="1rrkdusmezb1u" />
                </div>
                <div className="p-4" data-id="element-1573" data-mp="2fhy022ibifoi">
                  <p className="text-sm font-bold text-white" data-id="element-1574" data-mp="2kgizw0tnqxcf">Carwin</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1575" data-mp="2kfq1bn4ure5d">
                    Cliente 1:1
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Danel - Horizontal (16:9) - Below carousel */}
          <div className="max-w-3xl mx-auto mt-10" data-id="element-1576" data-mp="ik0o0zr0wdem">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1577" data-mp="iks7jc7cikoj">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1578" data-mp="8u7dm22ma4by">
                <iframe src="https://player.vimeo.com/video/1163511759?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Danel Testimonial en Entrevista" data-id="element-1579" data-mp="3vnsg3vukwkn" />
              </div>
              <div className="p-4" data-id="element-1580" data-mp="388avor4nfglq">
                <p className="text-sm font-bold text-white" data-id="element-1581" data-mp="38780i70ams00">Danel</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1582" data-mp="39ppzxrhmjg91">
                  Cliente 1:1 — Entrevista
                </p>
              </div>
            </div>
          </div>

          {/* Santi - Horizontal (16:9) - Below Danel */}
          <div className="max-w-3xl mx-auto mt-6" data-id="element-1583" data-mp="2zqr273yed50t">
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:border-[#00f7fc]/30 transition-colors" data-id="element-1584" data-mp="34pu4igmzsx53">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-1585" data-mp="2qxnp4wrnyu6p">
                <iframe src="https://player.vimeo.com/video/1181337901?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Santi Latest testimonio" data-id="element-1586" data-mp="2vri5prbz2t1k" />
              </div>
              <div className="p-4" data-id="element-1587" data-mp="1tf8mv5hnngld">
                <p className="text-sm font-bold text-white" data-id="element-1588" data-mp="1of2s3gg39dz2">Santi</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-1589" data-mp="22e2f6jnydkt4">
                  Cliente 1:1
                </p>
              </div>
            </div>
          </div>
        </motion.section>

        {/* 6. QUALIFICATION SECTION */}
        <motion.section {...fadeIn} className="max-w-5xl mx-auto px-4 mb-24" data-id="element-1590" data-mp="2cayrl0gz2r2y">
          <div className="text-center mb-12" data-id="element-1591" data-mp="27dyl4og7nmbb">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1592" data-mp="27cwzxr5hdjfv">
              ¿Es Para Ti?
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1593" data-mp="2h2ylocad2prm">
              Solo Trabajo Con Las Personas Correctas
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1594" data-mp="2v1yd1rp9dirh">
            {/* YES Column */}
            <div className="bg-emerald-900/10 border border-emerald-500/20 rounded-2xl p-8" data-id="element-1595" data-mp="2q4pqzg0zouky">
              <h3 className="text-xl font-bold text-emerald-400 mb-8 flex items-center gap-3" data-id="element-1596" data-mp="3a6kk6053ikcu">
                <CheckCircle className="w-6 h-6" data-id="element-1597" data-mp="3e6kx1gcjqnhs" />
                Este coaching ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-1598" data-mp="3ize2y7jr41vg">
                {[{
                t: 'Dueños de ecommerce',
                d: 'Que quieren escalar sus ventas con paid traffic y sistemas de retención.'
              }, {
                t: 'Creadores de productos digitales',
                d: 'Que quieren lanzar y vender con funnels de alta conversión.'
              }, {
                t: 'Emprendedores con oferta validada',
                d: 'Que quieren pasar de $10k a $100k/mes con estrategia y sistemas.'
              }, {
                t: 'Líderes de MLM',
                d: 'Que quieren construir su marca personal y reclutar digitalmente.'
              }, {
                t: 'Marcas DTC',
                d: 'Que quieren dominar Meta Ads y YouTube Ads para escalar agresivamente.'
              }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1599" data-mp="24xq47pvjam4i" data-mpi={i}>
                    <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-1600" data-mp="1zz55xvzuecip" />
                    <div data-id="element-1601" data-mp="1v86hua8m4a4w">
                      <p className="text-white font-bold text-sm mb-1" data-id="element-1602" data-mp="1v7dl823db10h">
                        {item.t}
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1603" data-mp="1q7iv40rf2fgh">
                        {item.d}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>

            {/* NO Column */}
            <div className="bg-red-900/10 border border-red-500/20 rounded-2xl p-8" data-id="element-1604" data-mp="1c911xniqsar6">
              <h3 className="text-xl font-bold text-red-400 mb-8 flex items-center gap-3" data-id="element-1605" data-mp="17b98gp2g8gkv">
                <XCircle className="w-6 h-6" data-id="element-1606" data-mp="36nlflg8nb612" />
                Este coaching NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-1607" data-mp="31oilgqu7ek7v">
                {['Personas que buscan resultados sin invertir', 'Emprendedores que no están dispuestos a ejecutar', 'Quienes esperan resultados de la noche a la mañana', 'Personas sin capital para invertir en herramientas y ads'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1608" data-mp="q1f6bp0ya7kt" data-mpi={i}>
                    <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-1609" data-mp="q38a8wk6idp4" />
                    <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1610" data-mp="v19v9n160n38">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-1611" data-mp="1nnunsqtdn58d">
            <p className="text-gray-300 mb-8 text-lg" data-id="element-1612" data-mp="19po4cfp6d7s8">
              Si te identificaste con el primer grupo, el siguiente paso es
              simple: escríbeme por WhatsApp y cuéntame sobre tu negocio.
            </p>
            <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-4 px-8 transition-all duration-300 transform hover:scale-[1.03] shadow-[0_0_20px_rgba(253,185,49,0.25)]" data-id="element-1613" data-mp="3ufdh8n6bijia">
              <MessageCircle className="w-5 h-5" data-id="element-1614" data-mp="4pzd9zq31jrk" />
              Quiero Hablar con Gabriel
            </a>
          </div>
        </motion.section>

        {/* 7. PROCESS SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 mb-24" data-id="element-1615" data-mp="3889hvlb6uuju">
          <div className="text-center mb-16" data-id="element-1616" data-mp="338n3v9njda9z">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1617" data-mp="339y798d2kg0k">
              El Proceso
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1618" data-mp="3hyudczvkfiyj">
              Cómo Funciona el Coaching VIP 1:1
            </p>
          </div>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-6 md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-[#00f7fc] before:via-[#00f7fc]/50 before:to-transparent" data-id="element-1619" data-mp="2pg6vrufs2m27">
            {[{
            num: '01',
            icon: Search,
            title: 'Diagnóstico Profundo',
            desc: 'Analizamos tu negocio, tu oferta, tu tráfico y tus números. Identificamos los cuellos de botella exactos que están limitando tu crecimiento.'
          }, {
            num: '02',
            icon: FileText,
            title: 'Plan de Acción Personalizado',
            desc: 'Diseñamos una estrategia específica para tu situación. No hay plantillas genéricas — cada plan es único para tu modelo de negocio, tu mercado y tus objetivos.'
          }, {
            num: '03',
            icon: Rocket,
            title: 'Implementación y Seguimiento',
            desc: 'Trabajamos juntos en la ejecución. Tienes acceso directo a mí para preguntas, revisiones y ajustes en tiempo real mientras escalas.'
          }].map((step, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group" data-id="element-1620" data-mp="35m7tpu3x6ymv" data-mpi={i}>
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-black border-2 border-[#00f7fc] shadow-[0_0_15px_rgba(0,247,252,0.3)] shrink-0 md:order-1 md:group-odd:-ml-6 md:group-even:-mr-6 z-10" data-id="element-1621" data-mp="u073iuofied3">
                  <step.icon className="w-5 h-5 text-[#00f7fc]" data-id="element-1622" data-mp="l0trpvcu1dp7" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white/5 border border-white/10 p-6 rounded-2xl ml-6 md:ml-0 hover:border-[#00f7fc]/30 transition-colors" data-id="element-1623" data-mp="g1h252uktsix">
                  <span className="text-[#00f7fc] font-black text-xl mb-2 block" data-id="element-1624" data-mp="18otqnikasaev">
                    {step.num}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-1625" data-mp="yyi9uvfim6qk">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1626" data-mp="1weecqabqznsd">
                    {step.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.section>

        {/* 8. FAQ SECTION */}
        <motion.section {...fadeIn} className="max-w-3xl mx-auto px-4 mb-24" data-id="element-1627" data-mp="1jhgbwv1bwstt">
          <div className="text-center mb-12" data-id="element-1628" data-mp="1fgeac7jxw4oo">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-1629" data-mp="1fhpei8haregb">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-1630" data-mp="1ofhwjkeel07e">Lo Que Más Me Preguntan</p>
          </div>

          <div className="space-y-4" data-id="element-1631" data-mp="22fkc2zz8nhjh">
            {faqs.map((faq, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-1632" data-mp="22dzhxbgu60m5" data-mpi={i}>
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-1633" data-mp="1yc4fg3n65h6s">
                  <span className="font-bold text-white pr-4" data-id="element-1634" data-mp="27693ygetygj5">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-[#00f7fc] transition-transform duration-300 shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-1635" data-mp="2m3jkw5a8sem9" />
                </button>
                <AnimatePresence data-id="element-1636" data-mp="2h2vkit04ilfd">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-1637" data-mp="30rjok81uq1ka">
                      <div className="p-6 pt-0 text-gray-400 text-sm leading-relaxed border-t border-white/5 mt-2" data-id="element-1638" data-mp="2vti1lc1b1i3j">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.section>

        {/* 9. FINAL CTA SECTION */}
        <motion.section {...fadeIn} className="max-w-4xl mx-auto px-4 text-center" data-id="element-1639" data-mp="2d0e93tztpbai">
          <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 border border-[#00f7fc]/20 rounded-3xl p-10 md:p-16 relative overflow-hidden" data-id="element-1640" data-mp="1y3wwz0jt7smw">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-[#00f7fc]/10 blur-[100px] pointer-events-none" data-id="element-1641" data-mp="231yevi5i1lws"></div>

            <div className="relative z-10" data-id="element-1642" data-mp="1f7odafbta0nh">
              <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-1643" data-mp="1f6mrbft9btqz">
                ¿Listo Para Escalar?
              </h2>
              <p className="text-xl text-[#00f7fc] font-bold mb-6 uppercase tracking-wider" data-id="element-1644" data-mp="1a5yxkmdn8yt2">
                El Próximo Paso Es Una Conversación
              </p>
              <p className="text-gray-400 text-lg mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-1645" data-mp="22vnykzqcsyuo">
                Escríbeme por WhatsApp, cuéntame sobre tu negocio y tus
                objetivos. Si veo que puedo ayudarte, agendamos una llamada de
                diagnóstico sin costo.
              </p>

              <div className="w-full max-w-md mx-auto mb-6" data-id="element-1646" data-mp="1nz6r4jlac4de">
                <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
                boxShadow: '0 0 20px rgba(253, 185, 49, 0.25), 0 0 40px rgba(253, 185, 49, 0.1)'
              }} data-id="element-1647" data-mp="hk5t88cp9c46">
                  <span className="absolute inset-0 rounded-xl animate-pulse" style={{
                  boxShadow: '0 0 25px rgba(253, 185, 49, 0.35), 0 0 50px rgba(253, 185, 49, 0.15)'
                }} data-id="element-1648" data-mp="32xkqc0mh1yh4" />
                  <MessageCircle className="relative z-10 w-6 h-6" data-id="element-1649" data-mp="3bvwdtts1kg5c" />
                  <span className="relative z-10" data-id="element-1650" data-mp="3gwanthd7e060">
                    Contáctame Ahora en WhatsApp
                  </span>
                  <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-1651" data-mp="3luc4jvn5pneb">
                    <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-1652" data-mp="1mk41pnirtyyx" />
                  </div>
                </a>
              </div>

              <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-500 font-medium" data-id="element-1653" data-mp="3i0kll3nbscxz">
                <CheckCircle className="w-4 h-4 text-emerald-500" data-id="element-1654" data-mp="3qz5xwh27evqb" />
                <span data-id="element-1655" data-mp="3qxbnhwok6m0h">
                  Respuesta en menos de 24 horas · Sin compromiso · 100%
                  confidencial
                </span>
              </div>
            </div>
          </div>
        </motion.section>
      </main>

      <Footer data-id="element-1656" data-mp="2u9owiea97vuf" />
    </div>;
}